import { TableColumn } from '@sdir/utilities/lib/types/tables';
import { createIntl, createIntlCache } from 'react-intl';
import messages from '../localization/localization';

const cache = createIntlCache();
const lang = window.location.pathname?.split('/')?.includes('no') ? 'no' : 'en';
const fm = createIntl(
  {
    locale: lang,
    messages: messages[lang as keyof typeof messages],
  },
  cache
).formatMessage;

export interface ApplicationRow {
  createdAt?: string;
  name?: any;
  status?: any;
  paidAt?: any;
  nationality?: any;
  contactEmail?: any;
  onBehalfOf?: any;
  actions?: any;
}

export const ApplicationTableHeader: TableColumn<ApplicationRow>[] = [
  {
    label: fm({ id: 'application.table.header.status' }),
    key: 'status',
  },
  {
    label: fm({ id: 'application.table.header.createdAt' }),
    key: 'createdAt',
  },
  {
    label: fm({ id: 'application.table.header.name' }),
    key: 'name',
  },
  {
    label: fm({ id: 'application.table.header.payment' }),
    key: 'paidAt',
  },
  {
    label: fm({ id: 'application.table.header.nationality' }),
    key: 'nationality',
  },
  {
    label: fm({ id: 'application.table.header.contactEmail' }),
    key: 'contactEmail',
  },
  {
    label: '',
    key: 'actions',
  },
];

export const ExternalApplicationTableHeader: TableColumn<ApplicationRow>[] = [
  {
    label: fm({ id: 'application.table.header.status' }),
    key: 'status',
  },
  {
    label: fm({ id: 'application.table.header.createdAt' }),
    key: 'createdAt',
  },
  {
    label: fm({ id: 'application.table.header.name' }),
    key: 'name',
  },
  {
    label: fm({ id: 'application.table.header.payment' }),
    key: 'paidAt',
  },
  {
    label: fm({ id: 'application.table.header.nationality' }),
    key: 'nationality',
  },
  {
    label: fm({ id: 'application.table.header.onBehalfOf' }),
    key: 'onBehalfOf',
  },
  {
    label: '',
    key: 'actions',
  },
];

export const MobileApplicationTableHeader: TableColumn<ApplicationRow>[] = [
  {
    label: fm({ id: 'application.table.header.status' }),
    key: 'status',
  },
  {
    label: fm({ id: 'application.table.header.name' }),
    key: 'name',
  },
  {
    label: '',
    key: 'actions',
  },
];

export interface ApplicationChildRow {
  status: string;
  endorsement: string;
  actions: any;
}

export const ApplicationChildTableHeader: TableColumn<ApplicationChildRow>[] = [
  {
    label: fm({ id: 'application.table.header.status' }),
    key: 'status',
  },
  {
    label: fm({ id: 'application.table.header.endorsement' }),
    key: 'endorsement',
  },
  {
    label: '',
    key: 'actions',
  },
];

export interface ReporteeRow {
  note: string;
  email: string;
  status: string;
  actions: any;
}

export const ReporteesTableHeader: TableColumn<ReporteeRow>[] = [
  {
    label: fm({ id: 'usermanagement.table.note' }),
    key: 'note',
  },
  {
    label: fm({ id: 'general.form.email' }),
    key: 'email',
  },
  {
    label: fm({ id: 'usermanagement.table.status' }),
    key: 'status',
  },
  {
    label: '',
    key: 'actions',
  },
];

export interface CertificatesSummaryRow {
  endorsement: string;
  nationalCertificate: string;
  issuedBy: string;
  certificateNumber: string;
  expiry: string;
}

export const CertificatesSummaryHeaders: TableColumn<CertificatesSummaryRow>[] = [
  {
    label: 'Endorsement',
    key: 'endorsement',
  },
  {
    label: 'National certificate',
    key: 'nationalCertificate',
  },
  {
    label: 'Issued by',
    key: 'issuedBy',
  },
  {
    label: 'Certificate number',
    key: 'certificateNumber',
  },
  {
    label: 'Date of expiry',
    key: 'expiry',
  },
];
